<template>
  <div class="modal-backdrop">
    <div class="modal-container">
      <div class="modal-content">
        <img src="@/assets/icons/icon-el.svg" alt class="modal-logo" />

        <div class="form-title-modal" v-if="this.usuario">
          <span class="form-title-modal">Bem-vindo(a) {{ this.usuario.pessoa.nomeGeral }}, Login:
            {{ this.usuario.pessoa.numeroDocumentoJuridico }}</span>
          <br />
          <span class="form-subtitle-modal">Preencha os campos abaixo para registrar sua nova senha.</span>
        </div>

        <div class="modal-body">
          <div class="d-flex">
            <div class="col-md-8 mb-3" style="margin-bottom: 3rem !important; width: 40%;">
              <div class="group">
                <input required type="password" class="input" v-model="senha" maxlength="50">
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Senha</label>
              </div>
            </div>
          </div>
          
          <div class="d-flex">
            <div class="col-md-8 mb-3" style="margin-bottom: 3rem !important; width: 40%;">
              <div class="group">
                <input required type="password" class="input" v-model="contraSenha" maxlength="50">
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>Repetir Senha</label>
              </div>
            </div>
          </div>
        </div>

        <div class="botoes-avancar-voltar">
          <button label="Registrar" @click="handleRecuperarSenha()" class="btnAvançar" id="btnAvançar">Registrar Senha</button>
          <button label="Página Inicial" @click="paginaInicial()" class="btnPaginaInicial">Pagina Inicial</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import RecuperaSenha from "../models/acesso/RecuperaSenha";

export default {
  name: "recuperarSenha",

  data() {
    return {
      erro: null,
      loading: false,
      chave: null,
      senha: null,
      contraSenha: null,
      usuario: null
    };
  },
  created() {
    this.loading = true;
    this.chave = this.$route.query.chave;
    this.currentUser = LoginService.currentUserValue;
    if (this.currentUser) {
      LoginService.logOut();
      location.reload();
    }

    if (!this.chave || this.chave == "undefined") {
      this.$router.push("/");
      return;
    }
    LoginService.buscarUsuarioPorChave(this.chave)
      .then(
        response => {
          this.usuario = response.data;
        },
        error => {
          this.$root.$emit("alert:warn", error.response.data);
          this.$router.push("/");
        }
      )
      .then(() => {
        this.loading = false;
      });
  },
  mounted() { },
  methods: {
    paginaInicial() {
      this.$router.push("/");
    },
    handleRecuperarSenha() {
      this.loading = true;
      if (!this.senha || !this.contraSenha) {
        this.$root.$emit(
          "alert:warn",
          "É necesário informar a Senha e Repetir a Senha!"
        );
        return;
      } else if (this.senha != this.contraSenha) {
        this.$root.$emit(
          "alert:warn",
          "A senha de Repetição não confere com a nova senha informada!"
        );
        return;
      }
      this.recuperaSenha = new RecuperaSenha();
      this.recuperaSenha.chave = this.chave;
      this.recuperaSenha.senha = this.senha;

      LoginService.novaSenha(this.recuperaSenha)
        .then(
          response => {
            console.log(response);
            this.$root.$emit(
              "alert:success",
              "Nova Senha registrada com sucesso!"
            );
            this.$router.push("/");
          },
          error => {
            this.$root.$emit("alert:warn", error.response.data);
          }
        )
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>

/* @import 'variables.css'; */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1D2F49;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: scroll;
}

.modal-container {
  background: #EBEBEB;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  max-width: 1000px;
  min-width: 280px;
  width: 90%;
}

.modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  background-color: #EBEBEB;
  border: none;
}

.modal-logo {
  max-width: 200px;
  margin-bottom: 1rem;
}

.modal-body {
  width: 50%;
  height: 147px;
}


.form-title-modal {
    color: black;
    font-size: 18px;
}

.form-subtitle-modal {
    font-size: 20px;
    font-family: var(--primary-font);
    color: var(--terciary-color);
    font-weight: 800;
    margin: 0px;
}


.modal-footer {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  align-items: center;
  border: none;
}
.group {
 position: relative;
}

.input {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  max-width: 400px;
  border: none;
  border-bottom: 1.5px solid var(--primary-color);
  background: transparent;
}

.input:focus {
 outline: none;
}

label {
 color: var(--primary-color);
 font-size: 18px;
 font-weight: normal;
 position: absolute;
 pointer-events: none;
 left: 5px;
 top: 10px;
 transition: 0.2s ease all;
 -moz-transition: 0.2s ease all;
 -webkit-transition: 0.2s ease all;
}

.input:focus ~ label, .input:valid ~ label {
 top: -20px;
 font-size: 18px;
 color: #5264AE;
}

.bar {
 position: relative;
 display: block;
 max-width: 400px;
}

.bar:after {
 content: '';
 height: 2px;
 width: 0;
 bottom: 1px;
 position: absolute;
 background: #5264AE;
 transition: 0.2s ease all;
 -moz-transition: 0.2s ease all;
 -webkit-transition: 0.2s ease all;
}

.bar:after {
  left: 0;
}

.input:focus ~ .bar:before, .input:focus ~ .bar:after {
 width: 400px;
}

.highlight {
 position: absolute;
 height: 60%;
 width: 100px;
 top: 25%;
 left: 0;
 pointer-events: none;
 opacity: 0.5;
}

.input:focus ~ .highlight {
 animation: inputHighlighter 0.3s ease;
}

@keyframes inputHighlighter {
 from {
  background: #5264AE;
 }

 to {
  width: 0;
  background: transparent;
 }
}
.btn-registrar-modal {
  position: relative;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  color: #ffffff;
  background-color: #2eac00;
  border: none;
  border-radius: 50px;
  overflow: hidden;
  z-index: 1;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  width: 230px;
}

.btn-registrar-modal:hover {
  transform: scale(1.05);
  color: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.btn-registrar-modal:active,
.btn-pagina-inicial-modal:active {
  transform: scale(0.9);
}

.btn-registrar-modal::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, #297e15, #2df600);
  transition: all 0.4s ease-in-out;
  z-index: -1;
  border-radius: 50px;
}

#btn-pagina-inicial-modal::before {
  background: linear-gradient(to right, #007bff, #00bfff);
  border: none;
}

#btn-pagina-inicial-modal {
  background-color: white;
  color: var(--primary-color);
  border: 1.5px solid var(--primary-color);
}

.btn-registrar-modal:hover::before {
  left: 0;
}
@media screen and (max-width: 380px) {
  .modal-backdrop {
    overflow-y: clip;
  }
}

</style>

